import clientFactory from "../factories/http_client";
import {API} from "../api/api";

class ProjectCategoryService {

	/** @return  Promise<AxiosResponse<T>> */
	get = (id) => {
		return clientFactory.client(API.data.scope)
		                    .request({
			                             method: API.data.project_categories.id.method,
			                             url: API.data.project_categories.id.url(id)
		                             });
	};

	/** @return  Promise<AxiosResponse<T>> */
	getAll = () => {
		return clientFactory.client(API.data.scope)
		                    .request({
			                             method: API.data.project_categories.method,
			                             url: API.data.project_categories.url
		                             });
	};

	/** @return  Promise<AxiosResponse<T>> */
	create = (category) => {
		return clientFactory.client(API.data.scope)
		                    .request({
			                             method: API.data.project_categories.create.method,
			                             url: API.data.project_categories.create.url,
			                             data: API.data.project_categories.create.build(category),
			                             headers: {
				                             'Content-Type': 'application/json',
			                             }
		                             });
	};

	/** @return  Promise<AxiosResponse<T>> */
	save = (category) => {
		return clientFactory.client(API.data.scope)
		                    .request({
			                             method: API.data.project_categories.save.method,
			                             url: API.data.project_categories.save.url,
			                             data: API.data.project_categories.save.build(category),
			                             headers: {
				                             'Content-Type': 'application/json',
			                             }
		                             });
	};

	/** @return  Promise<AxiosResponse<T>> */
	delete = (categoryId) => {
		return clientFactory.client(API.data.scope)
		                    .request({
			                             method: API.data.project_categories.delete.method,
			                             url: API.data.project_categories.delete.url,
			                             data: API.data.project_categories.delete.build(categoryId),
		                             });
	}
}

export default ProjectCategoryService